import 'bootstrap';
import 'bootstrap-select';
import 'bootstrap-select/js/i18n/defaults-fr_FR';
import 'simple-ajax-uploader';
import '@fancyapps/fancybox';
import 'js-base64';
import '@chenfengyuan/datepicker';
import '@chenfengyuan/datepicker/i18n/datepicker.fr-FR';
import 'jquery-sortablejs';
import 'leaflet';
import 'leaflet-geosearch';
import 'bootstrap-3-typeahead';
import 'jquery-serializeobject';


import './_languages.js';
import './_forms.js';
import './_confirmation.js';
import './_datepicker.js';
import './_maps.js';
import './_constructor.js';
import './_lightbox.js';
import './_lists.js';
import './_check-update.js';
import './_form_programme.js';
import './_form_client.js';
import './_form_action.js';
import './_form_tma.js';
import './_form_sav.js';
import './_form_user.js';
import './_dashboard.js';
import './_stock.js';
import './_form_alerteclient.js';
import './_popover.js';
import './_suivi.js';
import './_frm_plafonds.js';
import './_import_lots.js';

var sanitize = require("sanitize-filename");
window.sanitize = sanitize;
